import { Box } from '@chakra-ui/react'
import ScramblePreview from './ScramblePreview'

interface OLLCaseVisualizerProps {
  ollCase: string
  size?: { width: string; height: string }
}

// Map OLL cases to their setup moves (yellow on top)
const OLL_CASES: Record<string, string> = {
  // All Corners Oriented
  'OLL21': "z2 R U2 R' U' R U R' U' R U' R'",
  'OLL22': "z2 R U2 R2 U' R2 U' R2 U2 R",
  'OLL23': "z2 R2 D R' U2 R D' R' U2 R'",
  'OLL24': "z2 r U R' U' r' F R F'",
  'OLL25': "z2 F' r U R' U' r' F R",
  'OLL26': "z2 R U2 R' U' R U' R'",
  'OLL27': "z2 R U R' U R U2 R'",

  // T Shapes
  'OLL1': "z2 R U2 R2 F R F' U2 R' F R F'",
  'OLL2': "z2 F R U R' U' F' f R U R' U' f'",

  // Square Shapes
  'OLL3': "z2 f R U R' U' f'",
  'OLL4': "z2 f R U R' U' f' U' F R U R' U' F'",

  // C Shapes
  'OLL5': "z2 r' U2 R U R' U r",
  'OLL6': "z2 r U2 R' U' R U' r'",

  // Small L Shapes
  'OLL7': "z2 F R U R' U' F'",
  'OLL8': "z2 R U R' U' R' F R F'",

  // Fish Shapes
  'OLL9': "z2 R U R' U' R' F R2 U R' U' F'",
  'OLL10': "z2 R U R' U R' F R F' R U2 R'",

  // P Shapes
  'OLL11': "z2 f R U R' U' f' U F R U R' U' F'",
  'OLL12': "z2 F R U R' U' F' U f R U R' U' f'",

  // W Shapes
  'OLL13': "z2 R U2 R2 F R F' U2 M' U R U' r'",
  'OLL14': "z2 R' F R U R' F' R F U' F'",

  // Knight Move Shapes
  'OLL15': "z2 r' U' r R' U' R U r' U r",
  'OLL16': "z2 r U r' R U R' U' r U' r'",

  // Awkward Shapes
  'OLL17': "z2 R U R' U R' F R F' U2 R' F R F'",
  'OLL18': "z2 r U R' U R U2 r'",
  'OLL19': "z2 M U R U R' U' M' R' F R F'",
  'OLL20': "z2 M U R U R' U' M2 U R U' r'",

  // Dot Cases
  'OLL28': "z2 r U R' U' M U R U' R'",
  'OLL29': "z2 M U R U R' U' R' M' R U' R U' R'",
  'OLL30': "z2 F U R U2 R' U' R U2 R' U' F'",
  'OLL31': "z2 R' U' F U R U' R' F' R",

  // L Shapes
  'OLL32': "z2 R U B' U' R' U R B R'",
  'OLL33': "z2 R U R' U' R' F R F'",

  // Line Cases
  'OLL34': "z2 R U R2 U' R' F R U R U' F'",
  'OLL35': "z2 R U2 R2 F R F' R U2 R'",

  // All Edges Oriented
  'OLL36': "z2 R U R' U R U2 R'",
  'OLL37': "z2 R U2 R' U' R U' R'"
}

const OLLCaseVisualizer = ({ ollCase, size = { width: '200px', height: '150px' } }: OLLCaseVisualizerProps) => {
  const setupMoves = OLL_CASES[ollCase]
  
  if (!setupMoves) {
    return null
  }

  return (
    <Box>
      <ScramblePreview
        scramble={setupMoves}
        size={size}
        visualization="3D"
        event="333"
      />
    </Box>
  )
}

export default OLLCaseVisualizer 